export const getRouteParamAtIndex = (expressParams, index) => {
  return expressParams['0'].split('/')[index]
}
